var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.visible)?_c(_vm.sectionFile,{tag:"component",attrs:{"section":_vm.section,"sections":_vm.sections,"rows":_vm.rows}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }